import React, { createContext, useContext } from 'react';

import type { KnowledgeArticle } from '../../ui/proforma-request-create/utils/knowledge-base-suggestions/types';
import type { KnowledgeBaseSuggestionsContextProviderProps } from './types';

const SummaryFieldIdContext = createContext<string | null>(null);
const KnowledgeBaseArticlesContext = createContext<KnowledgeArticle[]>([]);

export const KnowledgeBaseSuggestionsContextProvider = ({
	summaryFieldId,
	knowledgeBaseArticles,
	children,
}: KnowledgeBaseSuggestionsContextProviderProps) => {
	return (
		<SummaryFieldIdContext.Provider value={summaryFieldId}>
			<KnowledgeBaseArticlesContext.Provider value={knowledgeBaseArticles}>
				{children}
			</KnowledgeBaseArticlesContext.Provider>
		</SummaryFieldIdContext.Provider>
	);
};

export const useSummaryFieldId = () => useContext(SummaryFieldIdContext);
export const useKnowledgeBaseArticles = () => useContext(KnowledgeBaseArticlesContext);
